import "bootstrap/dist/css/bootstrap.min.css";
import "./Fonts/Inter/stylesheet.css";
import "./App.css";
import { setWindow } from '../../reducers/models/size'

import {
  ProjectUpdateReceive, ProjectRemoveReceive
  , LabelUpdateReceive, LabelRemoveReceive, LabelObjectUpdateReceive, LabelProjectUpdateReceive
  , ParameterUpdateReceive, ParameterRemoveReceive, ParameterObjectUpdateReceive, ParameterProjectUpdateReceive
  , BoardUpdateReceive
  , TaskRUpdateReceive, TaskRUserUpdateReceive, TaskRTimetableUpdateReceive, TaskRTrackerUpdateReceive
  , UserRemoveReceive, UserUpdateReceive, UserListUpdateReceive
  , TaskUpdate
  , WidgetUpdateReceive, WidgetHtmlUpdateReceive, WdgetFileUpdateReceive, WidgetParameterUpdateReceive
  , SettingUserUpdateReceive, TaskRLabelUpdateReceive, TaskRChecklistUpdateReceive
  , RequestInUpdateReceive, RequestOutUpdateReceive
  , TicketMessageUpdateReceive, BotMaxUpdateReceive
  , BillingCompanyUpdateReceive, BillingTransactionUpdateReceive
  , CompanyReceive
} from "../../SignalR/Hub";
import { useEffect } from "react";
import { useDispatch } from "react-redux";


function App() {
  const dispatch = useDispatch()

  CompanyReceive();

  RequestInUpdateReceive();
  RequestOutUpdateReceive();

  ProjectUpdateReceive();
  ProjectRemoveReceive();

  ParameterUpdateReceive();
  ParameterRemoveReceive();
  ParameterObjectUpdateReceive();
  ParameterProjectUpdateReceive();

  LabelUpdateReceive();
  LabelRemoveReceive();
  LabelObjectUpdateReceive();
  LabelProjectUpdateReceive();

  //ДОСКИ
  BoardUpdateReceive();//Обновит доску


  TaskRUpdateReceive();
  TaskRTrackerUpdateReceive();
  TaskRUserUpdateReceive();
  TaskRTimetableUpdateReceive();
  TaskRLabelUpdateReceive();
  TaskRChecklistUpdateReceive();

  //ПОЛЬЗОВАТЕЛИ
  UserRemoveReceive();
  UserUpdateReceive();
  UserListUpdateReceive();

  //ЗАДАЧИ
  TaskUpdate();

  //WIDGET
  WidgetUpdateReceive();
  WidgetHtmlUpdateReceive();
  WdgetFileUpdateReceive();
  WidgetParameterUpdateReceive();

  SettingUserUpdateReceive();
  BotMaxUpdateReceive();
  TicketMessageUpdateReceive();

  //BILLING
  BillingCompanyUpdateReceive();
  BillingTransactionUpdateReceive();

  /************************START REDUCER РАЗМЕРА ЭКРАНА********************************/
  useEffect(() => {
    dispatch(setWindow({ height: window.innerHeight, width: window.innerWidth }));

    const handleResize = () => {
      dispatch(setWindow({ height: window.innerHeight, width: window.innerWidth }));
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  /*************************END REDUCER РАЗМЕРА ЭКРАНА*********************************/


  return <div className="App">{ }</div>;
}

export default App;
